import { createModuleContext } from '@rebuild/utils/moduleContext';
import { ref } from 'vue';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';

const MODULE_NAME = 'finance_data_sz003010';

function buildBaseCtx() {
	return {};
}

const { provide: provideCurrentContext, use: useCurrentContext } = createModuleContext(MODULE_NAME, buildBaseCtx);

const useCurrentReactive = () => {
	const moduleId = 'finance_data_sz003010';

	const groupByYear = dataList => {
		// 按年份分组
		const groupedByYear = dataList.reduce((acc, item) => {
			const year = item.contentTime?.split('-')[0] || '-';
			if (!acc[year]) acc[year] = [];
			acc[year].push(item);
			return acc;
		}, {});
		// 转换为数组格式，按年份降序排序
		return Object.entries(groupedByYear)
			.sort(([yearA], [yearB]) => {
				const numYearA = parseInt(yearA, 10) || 0;
				const numYearB = parseInt(yearB, 10) || 0;
				return numYearB - numYearA;
			})
			.map(([year, values]) => ({ year, values }));
	};

	const { viewModule } = useModuleNavigation();
	const handlePreview = item => {
		viewModule('custom', item);
	};

	const { config, loadModuleConfig } = useModuleConfig();
	const moduleList = ref([]);
	const initModuleConfig = async () => {
		await loadModuleConfig(moduleId);
		const { customerModuleVOList = [] } = config.value;
		moduleList.value = customerModuleVOList.map(item => ({
			label: item.name,
			value: item.id
		}));
	};

	return {
		moduleId,
		groupByYear,
		handlePreview,
		moduleList,
		initModuleConfig
	};
};

export { provideCurrentContext, useCurrentContext, useCurrentReactive };
